import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
import { ref, toRefs, watch, onMounted, onUpdated, computed } from 'vue';
import { vDragable } from 'element-plus-table-dragable';
import { cloneDeep } from 'lodash';
import AppgCheckBox from '@/components/custom/AppgCheckBox.vue';
import { useCommonStore } from '@/store/modules/common';
import router from '@/router';
import { useOperateStore } from '@/store/modules/operate';
import { useLayoutStore } from '@/store/modules/layout';
export default {
  __name: 'AppgTable',
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    pageInfo: {
      type: Object
    },
    tableColumns: {
      type: Array,
      default: () => []
    },
    width: {
      type: [String],
      default: () => '100px'
    },
    maxHeight: {
      type: [String],
      default: () => '100%'
    },
    border: {
      type: Boolean,
      default: false
    },
    spanMethod: {
      type: Function,
      default: () => {}
    },
    isSend: {
      type: Boolean,
      default: false
    },
    sendLabel: {
      type: String,
      default: () => '전송'
    },
    isDetail: {
      type: Boolean,
      default: false
    },
    detailLabel: {
      type: String,
      default: () => '상세'
    },
    isModify: {
      type: Boolean,
      default: false
    },
    modifyLabel: {
      type: String,
      default: () => '수정'
    },
    isDelete: {
      type: Boolean,
      default: false
    },
    deleteLabel: {
      type: String,
      default: () => '삭제'
    },
    splitPoint: {
      type: Number,
      default: () => 0
    },
    noPageInfo: {
      type: Boolean,
      default: () => false
    },
    isSelectable: {
      type: Boolean,
      default: () => false
    },
    isDraggable: {
      type: Boolean,
      default: false
    },
    pageNoReverse: {
      type: Boolean,
      default: false
    },
    selectCondition: {
      type: Function,
      default: () => true
    },
    showSummary: {
      type: Boolean,
      default: () => false
    },
    summaryMethod: {
      type: Function,
      default: () => {}
    }
  },
  emits: ['fnView', 'fnSend', 'fnModify', 'fnDelete', 'dragRow', 'fnSelect'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    let {
      tableData,
      pageInfo,
      tableColumns,
      width,
      maxHeight,
      border,
      isSend,
      sendLabel,
      isDetail,
      detailLabel,
      isModify,
      modifyLabel,
      isDelete,
      deleteLabel,
      splitPoint,
      noPageInfo,
      spanMethod,
      isDraggable,
      isSelectable,
      pageNoReverse,
      showSummary,
      summaryMethod
    } = toRefs(props);
    const key = ref(1);
    onUpdated(() => {
      checkAllBoxId.value += 1;
    });
    const switchData = ref([]);
    const checkAllBoxId = ref(1);
    const isSelectedAll = computed(() => {
      return tableData.value.length === commonStore.checkedList.length;
    });
    const currentPath = computed(() => router.currentRoute.value);
    const layoutStore = useLayoutStore();
    const emit = __emit;
    const fnView = row => {
      layoutStore.setBeforePath(currentPath.value.fullPath);
      emit('fnView', row);
    };
    const fnSend = row => emit('fnSend', row);
    const fnModify = row => emit('fnModify', row);
    const fnDelete = row => emit('fnDelete', row);
    const fnSelect = row => emit('fnSelect', row);
    const commonStore = useCommonStore();
    watch(() => tableData.value, val => {
      switchData.value = val;
      key.value += 1;
    });
    watch(() => commonStore.checkedList, value => {});
    const check = val => {
      if (!Array.isArray(val)) {
        commonStore.checkedList = [];
        if (val) {
          commonStore.checkedList = cloneDeep(tableData.value);
        }
      }
    };
    const checkAll = all => {
      let result = tableData.value;
      // if (props.selectedName && !props.selectedRevers)
      //   result = tableData.value.filter((data) => data[props.selectedName] === true);
      // if (props.selectedName && props.selectedRevers)
      //   result = tableData.value.filter((data) => data[props.selectedName] === false);
      // if (!isEmpty(props.selectedFunction)) {
      //   result = props.selectedFunction(tableData.value);
      // }
      // console.log(result);
      // console.log(all);
      if (!all) selectedRows.value = result;else selectedRows.value = [];
    };
    const dragOption = [{
      selector: 'tbody',
      option: {
        animation: 150,
        onEnd: ({
          oldIndex,
          newIndex
        }) => {
          let copy = cloneDeep(switchData.value);
          if (oldIndex === newIndex) return;else if (oldIndex < newIndex) {
            // 0, 1
            const temp = cloneDeep(copy[oldIndex]);
            copy.splice(newIndex + 1, 0, temp);
            copy.splice(oldIndex, 1);
          } else {
            const temp = copy[oldIndex];
            copy.splice(newIndex, 0, temp);
            copy.splice(oldIndex + 1, 1);
          }
          switchData.value = copy;
          emit('dragResult', copy);
        }
      }
    }];
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_table = _resolveComponent("el-table");
      return _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        border: _unref(border) ?? false,
        data: _unref(tableData),
        "max-height": _unref(maxHeight) ?? '100%',
        "span-method": _unref(spanMethod) ?? (() => {}),
        "header-row-class-name": "thead-light",
        ref: "table",
        "show-summary": _unref(showSummary),
        "summary-method": _unref(summaryMethod),
        "row-key": `id` + Math.floor(Math.random() * 1000),
        key: key.value
      }, {
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "headerBox"), _unref(isSelectable) ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 0,
          "min-width": 40,
          "max-width": 70,
          align: "center",
          fixed: "left"
        }, {
          header: _withCtx(() => [(_openBlock(), _createBlock(AppgCheckBox, {
            checked: isSelectedAll.value,
            onInput: check,
            key: checkAllBoxId.value
          }, null, 8, ["checked"]))]),
          default: _withCtx(({
            row,
            index
          }) => [_createVNode(AppgCheckBox, {
            value: row,
            modelValue: _unref(commonStore).checkedList,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(commonStore).checkedList = $event)
          }, null, 8, ["value", "modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), _unref(isDraggable) ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 1,
          "min-width": 50,
          width: 100,
          align: "center",
          label: '',
          fixed: "left"
        }, {
          default: _withCtx(({
            row,
            $index
          }) => [_createVNode(_component_font_awesome_icon, {
            icon: ['fas', 'bars'],
            size: "xl"
          })]),
          _: 1
        })) : _createCommentVNode("", true), !_unref(noPageInfo) ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 2,
          label: "NO",
          fixed: _unref(width) !== '100%' ? 'left' : '',
          "min-width": "50px",
          "max-width": "70px",
          align: "center"
        }, _createSlots({
          _: 2
        }, [!!_unref(pageInfo) && !_unref(pageNoReverse) ? {
          name: "default",
          fn: _withCtx(({
            $index
          }) => [_createTextVNode(_toDisplayString((_unref(pageInfo)?.virtualNum ?? 1) - $index), 1)]),
          key: "0"
        } : !!_unref(pageInfo) && _unref(pageNoReverse) ? {
          name: "default",
          fn: _withCtx(({
            $index
          }) => [_createTextVNode(_toDisplayString((_unref(pageInfo).page - 1) * _unref(pageInfo).rowPerPage + ($index + 1)), 1)]),
          key: "1"
        } : undefined, !_unref(pageInfo) && !_unref(pageNoReverse) ? {
          name: "default",
          fn: _withCtx(({
            $index
          }) => [_createTextVNode(_toDisplayString(_unref(tableData).length - $index), 1)]),
          key: "2"
        } : !_unref(pageInfo) && _unref(pageNoReverse) ? {
          name: "default",
          fn: _withCtx(({
            $index
          }) => [_createTextVNode(_toDisplayString($index + 1), 1)]),
          key: "3"
        } : undefined]), 1032, ["fixed"])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "custom1"), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(splitPoint) ? _unref(tableColumns).slice(0, _unref(splitPoint)) : _unref(tableColumns), column => {
          return _openBlock(), _createBlock(_component_el_table_column, _mergeProps({
            key: column.label,
            align: "center",
            ref_for: true
          }, column), null, 16);
        }), 128)), _renderSlot(_ctx.$slots, "custom2"), _unref(splitPoint) ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 3
        }, _renderList(_unref(tableColumns).slice(_unref(splitPoint), _unref(tableColumns).length), column => {
          return _openBlock(), _createBlock(_component_el_table_column, _mergeProps({
            key: column.label,
            sortable: true,
            align: "center",
            ref_for: true
          }, column), null, 16);
        }), 128)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "custom3"), _unref(isSend) ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 4,
          fixed: _unref(tableData).length > 0 ? 'right' : false,
          "min-width": "40"
        }, {
          default: _withCtx(({
            row
          }) => [_createVNode(_component_el_tooltip, {
            content: _unref(sendLabel) ?? '발송',
            class: "cursor",
            placement: "top"
          }, {
            default: _withCtx(() => [_createElementVNode("a", {
              "data-toggle": "tooltip",
              onClick: $event => row ? fnSend(row) : fnSend()
            }, _cache[1] || (_cache[1] = [_createElementVNode("i", {
              class: "fas fa-paper-plane"
            }, null, -1)]), 8, _hoisted_1)]),
            _: 2
          }, 1032, ["content"])]),
          _: 1
        }, 8, ["fixed"])) : _createCommentVNode("", true), _unref(isDetail) ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 5,
          fixed: _unref(tableData).length > 0 ? 'right' : false,
          "min-width": "40"
        }, {
          default: _withCtx(({
            row
          }) => [_createVNode(_component_el_tooltip, {
            content: _unref(detailLabel) ?? '상세',
            class: "cursor",
            placement: "top"
          }, {
            default: _withCtx(() => [_createElementVNode("a", {
              "data-toggle": "tooltip",
              onClick: $event => fnView(row)
            }, _cache[2] || (_cache[2] = [_createElementVNode("i", {
              class: "fas fa-sign-in-alt"
            }, null, -1)]), 8, _hoisted_2)]),
            _: 2
          }, 1032, ["content"])]),
          _: 1
        }, 8, ["fixed"])) : _createCommentVNode("", true), _unref(isModify) ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 6,
          fixed: _unref(tableData).length > 0 ? 'right' : false,
          "min-width": "40"
        }, {
          default: _withCtx(({
            row
          }) => [_createVNode(_component_el_tooltip, {
            content: _unref(modifyLabel) ?? '수정',
            class: "cursor",
            placement: "top"
          }, {
            default: _withCtx(() => [_createElementVNode("a", {
              "data-toggle": "tooltip",
              onClick: $event => fnModify(row)
            }, _cache[3] || (_cache[3] = [_createElementVNode("i", {
              class: "fas fa-edit"
            }, null, -1)]), 8, _hoisted_3)]),
            _: 2
          }, 1032, ["content"])]),
          _: 1
        }, 8, ["fixed"])) : _createCommentVNode("", true), _unref(isDelete) ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 7,
          fixed: _unref(tableData).length > 0 ? 'right' : false,
          "min-width": "40"
        }, {
          default: _withCtx(({
            row
          }) => [_createVNode(_component_el_tooltip, {
            content: _unref(deleteLabel) ?? '삭제',
            class: "cursor",
            placement: "top"
          }, {
            default: _withCtx(() => [_createElementVNode("a", {
              "data-toggle": "tooltip",
              onClick: $event => fnDelete(row)
            }, _cache[4] || (_cache[4] = [_createElementVNode("i", {
              class: "fas fa-trash"
            }, null, -1)]), 8, _hoisted_4)]),
            _: 2
          }, 1032, ["content"])]),
          _: 1
        }, 8, ["fixed"])) : _createCommentVNode("", true)]),
        _: 3
      }, 8, ["border", "data", "max-height", "span-method", "show-summary", "summary-method", "row-key"])), [[_unref(vDragable), _unref(isDraggable) ? dragOption : []]]);
    };
  }
};